import type { TranslationKeys } from "@/hooks/useTranslation/catalogs"
import type { BillingPlanId } from "@/services/api/billingService"

export const PLAN_COPY: Record<
  BillingPlanId,
  {
    name: TranslationKeys
    features: readonly [TranslationKeys, TranslationKeys, TranslationKeys]
  }
> = {
  pro: {
    name: "UPGRADE/PLAN_PRO",
    features: [
      "UPGRADE/PLAN_PRO_FEATURE_1",
      "UPGRADE/PLAN_PRO_FEATURE_2",
      "UPGRADE/PLAN_PRO_FEATURE_3",
    ],
  },
}
